"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var _FormAnimatedWrapper = _interopRequireDefault(require("../FormAnimatedWrapper/FormAnimatedWrapper"));

var _FormTextAreaComponent = _interopRequireDefault(require("../FormTextAreaComponent/FormTextAreaComponent"));

//eslint-disable-next-line
var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {};
};

var Lockedstyles = {
  FormElement: {
    display: 'flex',
    flexDirection: 'column',
    width: "100%"
  },
  FormInput: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    boxSizing: 'border-box'
  }
};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    FormElement: theme.FormTextInput.FormElement,
    FormInput: theme.FormTextInput.FormInput,
    Input: {
      display: 'block',
      // borderRadius: "3px",
      border: '0px ',
      backgroundColor: 'transparent',
      boxSizing: 'border-box',
      pointerEvents: 'all',
      //Keep it here to set the full component height to harmonize with other inputs
      // minHeight: "25px",
      // lineHeight: "25px",
      // height: "30px"
      webkitAppearance: 'none ',
      outline: 'none ',
      background: 'none',
      '&:error': {
        webkitAppearance: 'none ',
        outline: 'none ',
        border: 'none ',
        boxShadow: 'none'
      },
      '&:invalid': {
        outline: 'none ',
        border: 'none ',
        boxShadow: 'none '
      },
      '&:focus': {
        webkitAppearance: 'none ',
        outline: 'none ',
        border: 'none ',
        boxShadow: 'none'
      },
      '&:active': {
        webkitAppearance: 'none ',
        outline: 'none ',
        border: 'none ',
        boxShadow: 'none'
      }
    },
    BottomMessageContent: theme.FormTextInput.BottomMessageContent,
    BottomMessageContentError: function BottomMessageContentError(props) {
      var ErrorStyleFinal = props.ErrorStyle ? props.ErrorStyle.color ? props.ErrorStyle.color : null : null;
      var ColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;

      if (ErrorStyleFinal) {
        return {
          color: ErrorStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return theme.FormTextInput.BottomMessageContentError;
      }
    },
    BottomMessageContentHelper: function BottomMessageContentHelper(props) {
      var ColorFinal = props.HelperStyle ? props.HelperStyle.color ? props.HelperStyle.color : null : null;

      if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return theme.FormTextInput.BottomMessageContentHelper;
      }
    },
    BottomMessageContentHidden: {
      visibility: 'hidden'
    }
  };
});
/**
 * Create a NavTopBar Wrapper that goes into a NavHorizontalBar Component
 */

var FormTextInput = /*#__PURE__*/_react["default"].forwardRef(function FormTextInput(props, ref) {
  var variant = props.variant,
      _props$meta = props.meta,
      touched = _props$meta.touched,
      invalid = _props$meta.invalid,
      error = _props$meta.error,
      dirty = _props$meta.dirty,
      pristine = _props$meta.pristine,
      modified = _props$meta.modified,
      name = props.name,
      label = props.label,
      curvalue = props.curvalue,
      placeHolder = props.placeHolder,
      HelperMessage = props.HelperMessage,
      required = props.required,
      InputType = props.InputType,
      multiline = props.multiline,
      RowsToDisplay = props.RowsToDisplay,
      MaxRows = props.MaxRows,
      readOnly = props.readOnly,
      disabled = props.disabled,
      LabelScale = props.LabelScale,
      StyleBorderErrorFocusTrue = props.StyleBorderErrorFocusTrue,
      Colors = props.Colors,
      InputFontProp = props.InputFontProp,
      LabelStyle = props.LabelStyle,
      InputStyle = props.InputStyle,
      BorderStyle = props.BorderStyle,
      HelperStyle = props.HelperStyle,
      ErrorStyle = props.ErrorStyle,
      inputVerticalPadding = props.inputVerticalPadding,
      other = (0, _objectWithoutProperties2["default"])(props, ["variant", "meta", "name", "label", "curvalue", "placeHolder", "HelperMessage", "required", "InputType", "multiline", "RowsToDisplay", "MaxRows", "readOnly", "disabled", "LabelScale", "StyleBorderErrorFocusTrue", "Colors", "InputFontProp", "LabelStyle", "InputStyle", "BorderStyle", "HelperStyle", "ErrorStyle", "inputVerticalPadding"]);
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));

  var InputRef = _react["default"].useRef(null);

  var TextAreaInputRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      IsFocus = _React$useState2[0],
      setIsFocus = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      HasValue = _React$useState4[0],
      setHasValue = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(false),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      HasError = _React$useState6[0],
      setHasError = _React$useState6[1];

  var _React$useState7 = _react["default"].useState(null),
      _React$useState8 = (0, _slicedToArray2["default"])(_React$useState7, 2),
      ErrorMessage = _React$useState8[0],
      setErrorMessage = _React$useState8[1]; // Synching the form and the input to allow initial value and reset from the form


  _react["default"].useEffect(function () {
    if (curvalue) {
      if (curvalue === undefined) {//skip undefined to prevent bugs
      } else {
        if (InputRef && InputRef.current) {
          InputRef.current.value = curvalue;
          setHasValue(true);
        }
      }
    }
  }, [curvalue, InputRef]); //Changing Error state based on props passed by the form values


  _react["default"].useEffect(function () {
    if (readOnly === true || disabled === true) {//Deactivate if ReadOnly or Disabled
    } else {
      if (!props.meta) {
        setHasError(false);
        setErrorMessage(null);
      } else {
        if (pristine === true && modified === false) {
          //Initial state -> Ignore errors
          setHasError(false);
          setErrorMessage(null);
        } else {
          // console.log("Normal State",invalid,error)
          if (invalid === true) {
            if (dirty === true) {
              setHasError(true);
              setErrorMessage(error);
            } else {
              setHasError(true);
              setErrorMessage(error); //   setHasError(false);
              //   setErrorMessage(null);
            }
          } else {
            setHasError(false);
            setErrorMessage(null);
          }
        }
      }
    }
  }, [touched, invalid, error, dirty, pristine, modified, disabled, props.meta, readOnly]); //Prevent Entering Letters if field type is number


  var InputKeyPressed = function InputKeyPressed(event) {
    var charCode = event.which ? event.which : event.keyCode;

    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  _react["default"].useEffect(function () {
    var InpRef = InputRef;

    if (readOnly === true || disabled === true) {//Deactivate if ReadOnly or Disabled
    } else if (InputType === 'number') {
      if (InpRef && InpRef.current) {
        InpRef.current.addEventListener('keypress', InputKeyPressed);
        return function cleanup() {
          InpRef.current.removeEventListener('keypress', InputKeyPressed);
        };
      }
    }
  }, [InputRef, readOnly, InputType, disabled]); //Setting the focus status to move the label


  var InputOnFocus = function InputOnFocus() {
    if (readOnly === true || disabled === true) {//Deactivate if ReadOnly or Disabled
    } else {
      setIsFocus(true);
    }
  };

  var InputOnBlur = function InputOnBlur(event) {
    //When leaving the input -> Changing the label position based on the presence of a value
    if (readOnly === true || disabled === true) {//Deactivate if ReadOnly or Disabled
    } else {
      var value = event.target.value;

      if (value) {
        setHasValue(true);
      } else {
        setHasValue(false);
      }

      setIsFocus(false);
    }
  };

  var InputOnChange = function InputOnChange(target, value) {
    if (props.input) {
      return props.input.onChange(target, value);
    } else {
      return target.value;
    } //Not required when using the form element -> Might be needed later outside of a form
    // let value = event.target.value;
    // if (!value) {
    //     setHasError(true);
    //     setErrorMessage("arnaud ne peut pas etre vide");
    // } else {
    //     if (value === "arnaud") {
    //         setHasError(true);
    //         setErrorMessage("arnaud est trop beau, mauvais choix");
    //     } else {
    //         setHasError(false);
    //         setErrorMessage(null);
    //     }
    // }

  };

  var BottomMessageClass = classes.BottomMessageContent;

  if (HasError) {
    BottomMessageClass = (0, _clsx["default"])(BottomMessageClass, classes.BottomMessageContentError);
  } else if (HelperMessage) {
    BottomMessageClass = (0, _clsx["default"])(BottomMessageClass, classes.BottomMessageContentHelper);
  } else {
    BottomMessageClass = (0, _clsx["default"])(BottomMessageClass, classes.BottomMessageContentHidden);
  }

  var BottomMessageContent = function BottomMessageContent() {
    if (HasError) {
      return ErrorMessage;
    } else if (HelperMessage) {
      return HelperMessage;
    } else {
      return 'No Message';
    }
  };

  var InputComponent = function InputComponent(FieldSetProps) {
    var InputClass = FieldSetProps.InputClass,
        InputMarginBottom = FieldSetProps.InputMarginBottom,
        FinalInputPadding = FieldSetProps.FinalInputPadding;

    if (multiline === true) {
      return /*#__PURE__*/_react["default"].createElement(_FormTextAreaComponent["default"], {
        currentValue: curvalue,
        InputRef: InputRef,
        TextAreaInputRef: TextAreaInputRef,
        autoComplete: "off",
        placeHolder: placeHolder,
        InputClass: InputClass,
        disabled: disabled,
        readOnly: readOnly,
        RowsToDisplay: RowsToDisplay,
        MaxRows: MaxRows,
        style: {
          resize: 'none',
          padding: FinalInputPadding,
          marginBottom: InputMarginBottom,
          fontSize: InputFontProp.fontSize ? InputFontProp.fontSize : theme.FormTextInput.InputFont.fontSize,
          fontFamily: InputFontProp.fontFamily ? InputFontProp.fontFamily : theme.FormTextInput.InputFont.fontFamily,
          fontWeight: InputFontProp.fontWeight ? InputFontProp.fontWeight : theme.FormTextInput.InputFont.fontWeight,
          width: '100%'
        },
        name: name,
        InputOnBlur: InputOnBlur,
        InputOnFocus: InputOnFocus,
        InputOnChange: InputOnChange
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement("input", {
        ref: InputRef,
        autoComplete: "off",
        placeholder: placeHolder,
        type: InputType,
        className: InputClass,
        disabled: disabled,
        readOnly: readOnly,
        style: {
          padding: FinalInputPadding,
          marginBottom: InputMarginBottom,
          fontSize: InputFontProp.fontSize ? InputFontProp.fontSize : theme.FormTextInput.InputFont.fontSize,
          fontFamily: InputFontProp.fontFamily ? InputFontProp.fontFamily : theme.FormTextInput.InputFont.fontFamily,
          fontWeight: InputFontProp.fontWeight ? InputFontProp.fontWeight : theme.FormTextInput.InputFont.fontWeight,
          width: '100%'
        },
        name: name // onChange={props.input ? props.input.onChange : null}
        ,
        onBlur: InputOnBlur,
        onFocus: InputOnFocus // onTouchStart={InputOntouchStart}
        // onTouchEnd={InputOnTouchEnd}
        ,
        onChange: InputOnChange // onInput={InputOnInput}

      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.FormElement,
    style: (0, _extends2["default"])({}, Lockedstyles.FormElement)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.FormInput,
    style: (0, _extends2["default"])({}, Lockedstyles.FormInput)
  }, /*#__PURE__*/_react["default"].createElement(_FormAnimatedWrapper["default"], (0, _extends2["default"])({
    label: label,
    InputRef: multiline ? TextAreaInputRef : InputRef,
    IsFocus: IsFocus,
    HasValue: HasValue,
    LabelScale: LabelScale,
    HasError: HasError,
    variant: variant,
    placeHolder: placeHolder,
    disabled: disabled,
    required: required,
    StyleBorderErrorFocusTrue: StyleBorderErrorFocusTrue,
    Colors: Colors,
    InputFontProp: InputFontProp,
    LabelStyle: LabelStyle,
    BorderStyle: BorderStyle,
    inputVerticalPadding: inputVerticalPadding,
    FormInputComponent: InputComponent,
    ErrorStyle: ErrorStyle,
    InputStyle: InputStyle
  }, other))), /*#__PURE__*/_react["default"].createElement("div", {
    className: BottomMessageClass,
    style: HelperStyle ? HelperStyle : null
  }, BottomMessageContent()));
});

FormTextInput.defaultProps = {
  variant: 'standard',
  meta: {
    touched: null,
    invalid: null,
    error: null,
    dirty: null,
    pristine: null,
    modified: null
  },
  name: 'FieldName',
  label: 'Field Label',
  placeHolder: null,
  HelperMessage: null,
  required: false,
  multiline: false,
  RowsToDisplay: '1',
  MaxRows: 3,
  InputType: 'text',
  readOnly: false,
  disabled: false,
  LabelScale: '0.75',
  //Range is 0.75 - 0.85 otherwise fonts will crack
  StyleBorderErrorFocusTrue: true,
  Colors: {
    Empty: null,
    Filled: null,
    Error: null,
    Focused: null,
    Disabled: null
  },
  InputFontProp: {
    fontSize: null,
    fontFamily: null,
    fontWeight: null
  },
  inputVerticalPadding: null,
  BorderStyle: {
    Empty: null,
    Focused: null,
    Error: null,
    Disabled: null,
    BoderRadius: null
  },
  HelperStyle: {
    fontFamily: null,
    fontSize: null,
    marginTop: null,
    color: null
  },
  ErrorStyle: {
    color: null
  },
  LabelStyle: {
    Empty: null,
    Filled: null,
    Focused: null,
    Disabled: null,
    Error: null
  },
  InputStyle: {
    Empty: null,
    Filled: null,
    Focused: null,
    Disabled: null,
    Error: null
  }
};
process.env.NODE_ENV !== "production" ? FormTextInput.propTypes = {
  /**
   * meta: internal
   */
  meta: _propTypes["default"].any,

  /**
   * variant: outlined, standard
   */
  variant: _propTypes["default"].string,

  /**
   * input name
   */
  name: _propTypes["default"].string,

  /**
   * input label
   */
  label: _propTypes["default"].string,

  /**
   * placeHolder value
   */
  placeHolder: _propTypes["default"].string,

  /**
   * HelperMessage : Text to be displayed below the input
   */
  HelperMessage: _propTypes["default"].string,

  /**
   * required
   */
  required: _propTypes["default"].bool,

  /**
   * input type : number, text,email,textarea,password,.....
   */
  InputType: _propTypes["default"].string,

  /**
   * multine
   */
  multiline: _propTypes["default"].bool,

  /**
   * Number of RowsToDisplay to open
   */
  RowsToDisplay: _propTypes["default"].string,

  /**
   * Max Number of Rows
   */
  MaxRows: _propTypes["default"].any,

  /**
   * readOnly
   */
  readOnly: _propTypes["default"].bool,

  /**
   * disabled
   */
  disabled: _propTypes["default"].bool,

  /**
   * LabelScale : 0,75. Range is between 0.75 and 0.85, otherwise the text effect will not work
   */
  LabelScale: _propTypes["default"].string,

  /**
   * StyleBorderErrorFocusTrue : default is true
   * If true then the color of the input is focused when focused otherwise the input color is error color
   */
  StyleBorderErrorFocusTrue: _propTypes["default"].bool,
  Colors: _propTypes["default"].object,

  /**
   * InputFontProp: {fontSize: null, fontFamily: null, fontWeight: null},
   * Fonts for the label and the input
   */
  InputFontProp: _propTypes["default"].object,

  /**
   * LabelStyle: {Empty: null, Filled: null, Focused: null, Disabled: null, Error: null},
   * Customize the label (will override Colors)
   */
  LabelStyle: _propTypes["default"].object,

  /**
   * InputStyle: {Empty: null, Filled: null, Focused: null, Disabled: null, Error: null}
   * Customize the Input (will override Colors)
   */
  InputStyle: _propTypes["default"].object,

  /**
   * BorderStyle: {Empty: "1px solid grey", Focused: "1px solid grey", Error: "1px solid grey", Disabled: null, BoderRadius: "2px"},
   */
  BorderStyle: _propTypes["default"].object,

  /**
   * HelperStyle: {fontFamily: null, FontSize: null, marginTop: null, color: null},
   */
  HelperStyle: _propTypes["default"].object,

  /**
   * ErrorStyle: {fontFamily: "roboto", fontSize: "14px", marginTop: "2px", color: "red"},
   */
  ErrorStyle: _propTypes["default"].object,

  /**
   * Change the vertical padding of the input
   * inputVerticalPadding: "2px"
   */
  inputVerticalPadding: _propTypes["default"].string
} : void 0;
var _default = FormTextInput;
exports["default"] = _default;